import _ from 'lodash';
import Fuse from 'fuse.js';
import googleFonts from 'ub/fonts/font-service/google/fonts';
import FontServiceManager from 'ub/fonts/font-service/manager';
import fuseOptions from './fuse-options';

const fullFontList = _.cloneDeep(googleFonts.allFonts);
const fuse = new Fuse(fullFontList, fuseOptions);

let sortedFontList = fullFontList;

const updateFontAddedState = (fontList) => {
  const addedFontsNames = _.map(FontServiceManager.addedWebFonts, (font) => {
    return font.family;
  });

  _.forEach(fontList, (font) => {
    font.isAdded = _.contains(addedFontsNames, font.family);
  });

  return fontList;
};

const sortAddedFontsToTop = () => {
  const addedFontsFamilies = _.map(FontServiceManager.addedWebFonts, (font) => {
    return font.family;
  });

  const newFontList = _.sortBy(sortedFontList, (font) => {
    return !_.contains(addedFontsFamilies, font.family);
  });

  sortedFontList = updateFontAddedState(newFontList);
};

const filterAndUpdateFontList = (searchText) => {
  const filteredResults = searchText ? fuse.search(searchText) : fullFontList;

  sortedFontList = filteredResults;

  sortAddedFontsToTop();
};

const getFontsAtRange = (skip, limit) => {
  const slicedFontList = sortedFontList.slice(skip, limit);

  const slicedFontMap = _.map(slicedFontList, (fontItem) => {
    return {[fontItem.family]: fontItem};
  });

  return _.isEmpty(slicedFontMap) ? {} : Object.assign(...slicedFontMap);
};

const resetFontList = () => {
  sortedFontList = fullFontList;

  sortAddedFontsToTop();
};

export default {
  getFontsAtRange,
  filterAndUpdateFontList,
  resetFontList
};


// WEBPACK FOOTER //
// ./src/fonts/font-service/sort-filter.js